import { useTranslation } from 'react-i18next'

import { AddressForm, AddressFormValidations, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import useRegions from '@/common/hooks/useRegions/useRegions'

import useEditAddress from './hooks/useEditAddress'
import * as Styles from './styles'

const EditAddressModal = ({
  show,
  onClose,
  onEditAddress,
  loading,
  shippingAddress,
  deliveryMethod,
  headerMessage,
  title,
  requiresCustomerTaxId,
  warningComponent,
  showWarningComponent,
}) => {
  const { t } = useTranslation()
  const { address, handleAddressChange, getPhoneNumber } = useEditAddress({
    shippingAddress,
    showModal: show,
  })
  const { getProvincesByCountryCode } = useRegions()

  return (
    <Modal show={show} onClose={onClose} size="l" title={title || t('Dirección')}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {headerMessage ||
            t('Edita los datos de la dirección del cliente utilizada para la devolución de los productos')}
        </Text>
        <AddressForm
          shippingAddress={address}
          specialConstraints={deliveryMethod?.configuration}
          onChange={handleAddressChange}
          requiresHouseNumber={deliveryMethod?.requires_house_number}
          carrier={deliveryMethod?.carrier}
          allowEditProvince
          provinces={getProvincesByCountryCode(address?.country?.code)}
          requiresCustomerTaxId={requiresCustomerTaxId}
          customerTaxId={address?.customer?.tax_id}
        />
        {showWarningComponent && warningComponent}
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={() => onEditAddress(address)}
            loading={loading}
            disabled={
              loading ||
              !AddressFormValidations.isFormValid({
                deliveryMethod: { ...deliveryMethod, requires_address: true },
                address: address,
                timeRange: deliveryMethod?.time_range,
                isProvinceRequired: false,
                phone: getPhoneNumber(),
                specialConstraints: deliveryMethod?.configuration,
                pickupDate: deliveryMethod?.pickup_date,
                requiresCustomerTaxId,
              })
            }
            defaultLabel={t('Guardar dirección')}
            loadingLabel={t('Guardando dirección')}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default EditAddressModal
